<template>
  <div v-if="brandConfig.brand ==='blg-en' || brandConfig.brand ==='blg-am'" class="language-selector">
    <!-- Language Pill Button -->
    <button class="language-pill" @click="openModal">
      <span>{{ currentLanguageLabel }}</span>
      <svg class="chevron-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </button>

    <!-- Modal Overlay -->
    <transition name="fade">
      <div v-if="isModalOpen" class="modal-overlay" @click="closeModal">
        <transition name="slide-up">
          <div v-if="isModalOpen" class="modal-content" @click.stop>
            <div class="modal-header">
              <div class="brand-header">
                <img :src="brandLogoSrc" class="brand-logo" alt="BLG logo">
              </div>
              <h3>{{ translations.selectLanguage }}</h3>
              <button class="close-btn" @click="closeModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
            
            <div class="language-options">
              <button 
                class="language-option"
                :class="{ active: currentLanguage === 'en' }"
                @click="selectLanguage('en')"
              >
                <span class="language-name">English</span>
                <svg v-if="currentLanguage === 'en'" class="check-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </button>
              
              <button 
                class="language-option"
                :class="{ active: currentLanguage === 'am' }"
                @click="selectLanguage('am')"
              >
                <span class="language-name">አማርኛ</span>
                <svg v-if="currentLanguage === 'am'" class="check-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </button>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'LanguageSelector',
  
  props: {
    currentLanguage: {
      type: String,
      default: 'en'
    },
    translations: {
      type: Object,
      default: () => ({
        selectLanguage: 'Select Language',
        english: 'English',
        amharic: 'አማርኛ'
      })
    }
  },
  
  data() {
    return {
      isModalOpen: false
    }
  },
  
  computed: {
    ...mapState(['brandConfig']),
    currentLanguageLabel() {
      return this.currentLanguage === 'am' ? 'አማርኛ' : 'English'
    },
    brandLogoSrc() {
      return require(`@/brand/${this.brandConfig.brand}/assets/logo.png`)
    }
  },
  
  methods: {
    openModal() {
      this.isModalOpen = true
      document.body.style.overflow = 'hidden'
    },
    
    closeModal() {
      this.isModalOpen = false
      document.body.style.overflow = ''
    },
    
    selectLanguage(language) {
      this.$emit('change', language)
      this.closeModal()
    }
  },
  
  beforeDestroy() {
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.language-selector {
  position: relative;
}

.language-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 9999px;
  color: var(--color-text, #fff);
  font-size: 0.7rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.language-pill:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.globe-icon {
  flex-shrink: 0;
}

.chevron-icon {
  flex-shrink: 0;
  opacity: 0.7;
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
}

/* Modal Content */
.modal-content {
  position: relative;
  background:
      linear-gradient(90deg, #080A0E 0%, #1E293B 100%) padding-box;
  border-radius: 18px;
  width: min(100%, 560px);
  max-width: 360px;
  padding: 42px 32px 28px;
  border: 1px solid transparent;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);
  margin: 0 auto;
}

.modal-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 26px;
  margin-bottom: 28px;
}

.brand-header {
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-logo {
  width: 190px;
  height: auto;
  display: block;
}

.modal-header h3 {
  font-size: clamp(1.8rem, 4vw, 2.2rem);
  font-weight: 800;
  color: #FFFFFF;
  margin: 0;
  text-align: center;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  color: var(--color-text-secondary, #9ca3af);
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--color-text, #fff);
}

.language-options {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.language-option {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 317px;
  max-width: 100%;
  height: 48px;
  min-height: 48px;
  padding: 0 20px;
  background-color: #131924;
  border: 1px solid rgba(255, 255, 255, 0.02);
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.language-option:hover {
  background-color: #1a2230;
}

.language-option.active {
  background-color: #B3F50D;
  border-color: #B3F50D;
  color: #040404;
  border-radius: 4px;
}

.language-name {
  font-family: Inter, sans-serif;
  font-size: 1.05rem;
  font-weight: 700;
}

.check-icon {
  position: absolute;
  opacity: 0;
}

@media (max-width: 640px) {
  .modal-content {
    padding: 34px 18px 18px;
  }

  .brand-logo {
    width: 156px;
  }

  .language-option {
    width: 317px;
    height: 48px;
    min-height: 48px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(20px) scale(0.95);
  opacity: 0;
}
</style>
